@if (kort()) {
    <div class="dl-node-menu-uitleg"
         [class.dl-node-menu-uitleg--klikbaar]="!!vol()"
         [class.dl-node-menu-uitleg--zichtbaar]="wordtZichtbaar()"
         [style.top.px]="positie().vanBoven"
         [style.bottom.px]="positie().vanOnder"
         [style.left.px]="positie().links"
         (pointerenter)="opPointerEnter()"
         (pointerleave)="opPointerLeave()"
         (click)="opKlik($event)"
         (pointerdown)="blokkeer($event)"
         (pointerup)="blokkeer($event)">
        <div class="dl-node-menu-uitleg__html"
             [class.dl-node-menu-uitleg__html--alles-zichtbaar]="allesZichtbaar()"
             [innerHTML]="toonVol() ? vol() : kort()">
        </div>
    </div>
}
